module.exports = __webpack_public_path__ + "assets/75e62051e1ae8243ef24aa2f7d059a1f.png";